<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-data-table loading="true" :headers="headers" :items="quoteApis" ref="sortableTable" :search="search"
                    hide-actions disable-initial-sort class="elevation-1">
        <template slot="items" slot-scope="props">
          <tr class="sortableRow" id="rows">
            <td width="10%">{{ props.item.type }}</td>
            <td width="10%" >{{ props.item.api_name }}</td>
            <td width="10%" >{{ props.item.datetime }}</td>
            <td width="70%" ><code style="padding:24px;">{{ props.item.api_data }}</code></td>
          </tr>
        </template>
      </v-data-table>

      <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder" style="margin-top: 0px !important;">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
        </div>
      </div>
    </v-layout>

  </v-container>

</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: "Modal_clone_quote",
  data () {
    return {
      headers: [
        {text: 'Type', value: 'name', width: '10%'},
        {text: 'API', value: 'description', width: '10%'},
        {text: 'Date', value: 'description', width: '10%'},
        {text: 'Payload', value: 'created_on', width: '70%'}
      ]
    }
  },
  methods: {
    fncHideModal() {
      // this.$store.commit('hideModal');
      window.location.reload();
    },

  },
  computed: {
    ...mapGetters([
      'globalModalParams',
      'quoteApis'
    ])
  },
  beforeMount() {
    this.$store.dispatch('fncGetQuoteApi', this.globalModalParams.quote.id);
  }
}
</script>

<style scoped>

</style>
